// extracted by mini-css-extract-plugin
module.exports = {"label":"_13XMS","interactionState":"CFZWC","hoverBorder":"_1lC8P","hasPaddingOffset":"_2K6S-"};